import React, { useEffect, useState, useContext } from "react";
import MobileMenuSection from './MobileMenuSection';
import { AuthContext } from "../../Context/AuthContext"
import socialLinks from '../../utils/socialLinks';
import AnouncementsService from "../../Api/AnouncementsService";

const ClientHeader = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [announcements, setAnnouncements] = useState([]);
    const { cookies, logout, data, removeCookie } = useContext(AuthContext);
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    useEffect(() => {
        const service = new AnouncementsService();
        const fetchPublicAnnouncements = async () => {
            try {
                const response = await service.GetPublicAnouncements(1, 1);
                const items = Array.isArray(response?.data?.data) ? response.data.data : [];
                setAnnouncements(items);
            } catch (error) {
                setAnnouncements([]);
            }
        };
        fetchPublicAnnouncements();
    }, []);

    return (
        <>
            <header className="rbt-header rbt-header-7 rbt-transparent-header">
                <div className="rbt-sticky-placeholder" />
                <div className="rbt-header-top rbt-header-top-2 bg-not-transparent bg-gradient-7 color-white pt--15 pb--15 d-none d-xl-block">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7 col-md-5 col-12 d-none d-md-block">
                                <div className="fancy-menu-text fancu-menu-start d-flex justify-content-center w-100">
                                    {announcements.length > 0 ? (
                                        <>
                                            <style>{`
                                                .announcement-ticker{position:relative;overflow:hidden;white-space:nowrap;margin-left:0}
                                                .announcement-track{display:inline-block;padding-left:100%;animation:ticker 18s linear infinite}
                                                .announcement-item{margin-right:32px}
                                                @keyframes ticker{0%{transform:translateX(0)}100%{transform:translateX(-100%)}}
                                            `}</style>
                                            <div className="announcement-ticker">
                                            
                                                <div className="announcement-track">
                                                    {announcements.map(a => (
                                                        <span key={a.id} className="announcement-item"><strong>{a.title}</strong>: {a.content}</span>
                                                    ))}
                                                    {announcements.map(a => (
                                                        <span key={`dup-${a.id}`} className="announcement-item" aria-hidden="true"><strong>{a.title}</strong>: {a.content}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-7 col-12">
                                <div className="fancy-menu-address fancu-menu-end">
                                    <div className="address-content">
                                        <p>
                                            <i className="feather-map-pin" />
                                            <span>Mogappair, Chennai, India</span>
                                        </p>
                                        <p>
                                            <i className="feather-phone" />
                                            <span>
                                                <a href="#">+91-7808780874</a>
                                            </span>
                                        </p>
                                    </div>
                                    <div className="social-icon-wrapper">
                                        <ul className="social-icon social-default icon-naked">
                                            <li>
                                                <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                                                    <i className="feather-facebook" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                                                    <i className="feather-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                                                    <i className="feather-instagram" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                                                    <i className="feather-youtube" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rbt-header-wrapper bg-color-white color-white-variation header-sticky rbt-border-bottom-light">
                    <div className="container">
                        <div className="mainbar-row rbt-navigation-end align-items-center">
                            <div className="header-left">
                                <div className="logo">
                                    <a href="/">
                                        <img
                                            src="assets1/images/logo/logo.png"
                                            alt="Education Logo Images"
                                            className="img-fluid"
                                            style={{ maxHeight: '50px' }}
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="rbt-main-navigation d-none d-xl-block">
                                <nav className="mainmenu-nav">
                                    <ul className="mainmenu">
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="/" className="nav-link">Home</a>
                                        </li>
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="#courses" className="nav-link">Courses</a>
                                        </li>
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="/StudentDashboard" className="nav-link">Dashboard</a>
                                        </li>
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="#PL" className="nav-link">Verified P&L</a>
                                        </li>
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="#feedback" className="nav-link">Feedbacks</a>
                                        </li>
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="#FAQ" className="nav-link">FAQ</a>
                                        </li>
                                        <li className="has-dropdown has-menu-child-item">
                                            <a href="#footer" className="nav-link">About</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="header-right">
                                <div className="rbt-btn-wrapper d-none d-xl-block">
                                    {cookies.username ? (
                                        <a
                                            className="rbt-btn rbt-switch-btn btn-gradient btn-sm hover-transform-none"
                                            href="/"
                                        >
                                            <span data-text={cookies.username}>{cookies.username}</span>
                                        </a>
                                    ) : (
                                        <a
                                            className="rbt-btn rbt-switch-btn btn-gradient btn-sm hover-transform-none"
                                            href="/StudentLogin"
                                        >
                                            <span data-text="Sign In">Sign In</span>
                                        </a>
                                    )}
                                </div>
                                <div className="mobile-menu-bar d-block d-xl-none">
                                    <div className="hamberger">
                                        <button
                                            className="hamberger-button rbt-round-btn"
                                            onClick={toggleMobileMenu}
                                            aria-label="Toggle mobile menu"
                                        >
                                            <i className="feather-menu" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Start Search Dropdown  */}
                <div className="rbt-search-dropdown">
                    <div className="wrapper">
                        <div className="row">
                            <div className="col-lg-12">
                                <form action="#">
                                    <input type="text" placeholder="What are you looking for?" />
                                    <div className="submit-btn">
                                        <a className="rbt-btn btn-gradient btn-md" href="#">
                                            Search
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="rbt-separator-mid">
                            <hr className="rbt-separator m-0" />
                        </div>
                        <div className="row g-4 pt--30 pb--60">
                            <div className="col-lg-12">
                                <div className="section-title">
                                    <h5 className="rbt-title-style-2">Our Top Course</h5>
                                </div>
                            </div>
                            {/* Start Single Card  */}
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                <div className="rbt-card variation-01 rbt-hover">
                                    <div className="rbt-card-img">
                                        <a href="course-details.html">
                                            <img
                                                src="assets1/images/course/course-online-01.jpg"
                                                alt="Card image"
                                            />
                                        </a>
                                    </div>
                                    <div className="rbt-card-body">
                                        <h5 className="rbt-card-title">
                                            <a href="course-details.html">React Js</a>
                                        </h5>
                                        <div className="rbt-review">
                                            <div className="rating">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                            </div>
                                            <span className="rating-count"> (15 Reviews)</span>
                                        </div>
                                        <div className="rbt-card-bottom">
                                            <div className="rbt-price">
                                                <span className="current-price">$15</span>
                                                <span className="off-price">$25</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Card  */}
                            {/* Start Single Card  */}
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                <div className="rbt-card variation-01 rbt-hover">
                                    <div className="rbt-card-img">
                                        <a href="course-details.html">
                                            <img
                                                src="assets1/images/course/course-online-02.jpg"
                                                alt="Card image"
                                            />
                                        </a>
                                    </div>
                                    <div className="rbt-card-body">
                                        <h5 className="rbt-card-title">
                                            <a href="course-details.html">Java Program</a>
                                        </h5>
                                        <div className="rbt-review">
                                            <div className="rating">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                            </div>
                                            <span className="rating-count"> (15 Reviews)</span>
                                        </div>
                                        <div className="rbt-card-bottom">
                                            <div className="rbt-price">
                                                <span className="current-price">$10</span>
                                                <span className="off-price">$40</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Card  */}
                            {/* Start Single Card  */}
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                <div className="rbt-card variation-01 rbt-hover">
                                    <div className="rbt-card-img">
                                        <a href="course-details.html">
                                            <img
                                                src="assets1/images/course/course-online-03.jpg"
                                                alt="Card image"
                                            />
                                        </a>
                                    </div>
                                    <div className="rbt-card-body">
                                        <h5 className="rbt-card-title">
                                            <a href="course-details.html">Web Design</a>
                                        </h5>
                                        <div className="rbt-review">
                                            <div className="rating">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                            </div>
                                            <span className="rating-count"> (15 Reviews)</span>
                                        </div>
                                        <div className="rbt-card-bottom">
                                            <div className="rbt-price">
                                                <span className="current-price">$10</span>
                                                <span className="off-price">$20</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Card  */}
                            {/* Start Single Card  */}
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                <div className="rbt-card variation-01 rbt-hover">
                                    <div className="rbt-card-img">
                                        <a href="course-details.html">
                                            <img
                                                src="assets1/images/course/course-online-04.jpg"
                                                alt="Card image"
                                            />
                                        </a>
                                    </div>
                                    <div className="rbt-card-body">
                                        <h5 className="rbt-card-title">
                                            <a href="course-details.html">Web Design</a>
                                        </h5>
                                        <div className="rbt-review">
                                            <div className="rating">
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                                <i className="fas fa-star" />
                                            </div>
                                            <span className="rating-count"> (15 Reviews)</span>
                                        </div>
                                        <div className="rbt-card-bottom">
                                            <div className="rbt-price">
                                                <span className="current-price">$20</span>
                                                <span className="off-price">$40</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Card  */}
                        </div>
                    </div>
                </div>
                {/* End Search Dropdown  */}
            </header>

            {/* Add mobile menu with active class based on state */}
            <div className={`popup-mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                <div className="inner-wrapper">
                    <div className="inner-top">
                        <div className="content">
                            <div className="logo">
                                <a href="index.html">
                                    <img src="assets1/images/logo/logo.png" alt="Education Logo Images" />
                                </a>
                            </div>
                            <div className="rbt-btn-close">
                                <button
                                    className="close-button rbt-round-btn"
                                    onClick={toggleMobileMenu}
                                >
                                    <i className="feather-x" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <MobileMenuSection />
                </div>
            </div>
        </>
    );
};

export default ClientHeader;
